var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"flex flex-wrap"},[(_vm.colors && _vm.colors.length > 0)?_vm._l((_vm.colors),function(color,index){return _c('div',{key:index,staticClass:"coloricon mr-1 mb-1",class:color})}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }